import { getFormValues as getReduxFormValues } from 'redux-form';
import * as _ from 'lodash';

import FinanceSVG from 'login-components/Common/svg/FinanceSVG';
import HouseSVG from 'login-components/Common/svg/HouseSVG';
import LoanSVG from 'login-components/Common/svg/LoanSVG';
import InputMap from 'login-components/Common/Inputs/InputMap';
import { PaneFormHeaderProps } from 'login-components/Common/PaneLayout/PaneFormHeader';
import * as deploymentConfig from 'login-utils/deploymentConfig';

export const FORM_NAME = 'buyingPower';

export const FORM_CONFIG = {
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: FORM_NAME,
};

export interface FIELDS {
  creditScore: string;
  totalAssets: string;
  monthlyIncome: string;
  monthlyDebt: string;
  county: {
    countyName: string;
    stateCode: string;
  };
  interestRate: string;
  downPayment?: string;
  configGroup?: string;
}

export function getFormValues(state: ReduxState) {
  return getReduxFormValues(FORM_NAME)(state);
}

interface BuyingPowerCalculatorFormSection {
  header: PaneFormHeaderProps;
  inputs: FormInput[];
}

export const getFormSections = () => {
  return [
    {
      header: {
        iconComponent: FinanceSVG,
        text: 'Financial Info',
      },
      inputs: [
        {
          ...InputMap.UnformattedNumberInput,
          identifier: 'credit score',
          hidePlaceholder: true,
          name: 'creditScore',
          label: `Credit Score`,
          maxLength: 3,
        },
        {
          ...InputMap.MoneyInput,
          identifier: 'total assets',
          hidePlaceholder: true,
          name: 'totalAssets',
          label: `Total Assets`,
        },
        {
          ...InputMap.MoneyInput,
          identifier: 'monthly income',
          hidePlaceholder: true,
          name: 'monthlyIncome',
          label: `Monthly Income`,
        },
        {
          ...InputMap.MoneyInput,
          identifier: 'monthly debt',
          hidePlaceholder: true,
          name: 'monthlyDebt',
          label: `Monthly Debt`,
        },
      ],
    },
    {
      header: {
        iconComponent: HouseSVG,
        text: 'Property Info',
      },
      inputs: [
        {
          ...InputMap.CountySelector,
          identifier: 'county',
          hidePlaceholder: true,
          name: 'county',
          label: 'County/Municipality',
        },
      ],
    },
    {
      header: {
        iconComponent: LoanSVG,
        text: 'Loan Info',
      },
      inputs: _.compact([
        {
          ...InputMap.PercentageInput,
          identifier: 'interest rate',
          hidePlaceholder: false,
          placeholder: '4.125',
          name: 'interestRate',
          label: `Interest Rate`,
        },
        {
          ...InputMap.MoneyInput,
          identifier: 'down payment',
          hidePlaceholder: true,
          name: 'downPayment',
          optional: true,
          label: `Down Payment (optional)`,
        },
        _.get(deploymentConfig.get(), 'organization.id') === 'blend-borrower' && {
          ...InputMap.SelectInput,
          identifier: 'config group',
          hidePlaceholder: true,
          name: 'configGroup',
          label: 'Config Group',
          choices: [
            {
              value: 'wellsfargo',
              text: 'Wells Fargo',
            },
            {
              value: 'usbank',
              text: 'US Bank',
            },
            {
              value: 'blend-borrower',
              text: 'Blend Borrower',
            },
          ],
        },
      ]),
    },
  ] as BuyingPowerCalculatorFormSection[];
};

export const getAllInputs = () => {
  const formSections = getFormSections();
  return _.flatten(_.map(formSections, definition => definition.inputs));
};
